module.exports = __webpack_public_path__ + "img/quote-Bom@ico.cdb584f0.png";